var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup416(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#e3ebdc}.cls-4{fill:#486a41}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    transform: "translate(-1376 -493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_650",
    fill: "none",
    d: "M0 0H150V150H0z",
    transform: "translate(1376 493)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    transform: "translate(1384.738 514.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    cx: 46.723,
    cy: 46.723,
    r: 46.723,
    className: "cls-2",
    transform: "translate(0 6.629)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    cx: 19.539,
    cy: 19.539,
    r: 19.539,
    className: "cls-2",
    transform: "translate(93.447 6.629)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "AVO",
    fill: "#486a41",
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontSize: "16px",
    fontWeight: 600,
    transform: "translate(28.884 44.717)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AVO")), /*#__PURE__*/React.createElement("g", {
    id: "_003-file",
    transform: "translate(24.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    d: "M106 14.4H94a1.2 1.2 0 0 1-1.2-1.2v-12A1.2 1.2 0 0 0 91.6 0h-24A3.6 3.6 0 0 0 64 3.6V54a3.6 3.6 0 0 0 3.6 3.6h36a3.6 3.6 0 0 0 3.6-3.6V15.6a1.2 1.2 0 0 0-1.2-1.2zM104.8 54a1.2 1.2 0 0 1-1.2 1.2h-36a1.2 1.2 0 0 1-1.2-1.2V3.6a1.2 1.2 0 0 1 1.2-1.2h22.8v10.8a3.6 3.6 0 0 0 3.6 3.6h10.8z",
    className: "cls-4",
    transform: "translate(-64)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    transform: "translate(26.399 .002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    d: "M315.109 14.767l-14.4-14.4a1.2 1.2 0 0 0-1.7 1.7l14.4 14.4a1.2 1.2 0 0 0 1.7-1.7z",
    className: "cls-4",
    transform: "translate(-298.661 -.016)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_001-grab",
    transform: "rotate(8 -257.365 492.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    d: "M60.247 25.591c-1.095-7.161-1.5-9.84-2.738-17.72a7.3 7.3 0 0 0-8.13-6.294l-.125.019a6.8 6.8 0 0 0-4.338 2.555A7.13 7.13 0 0 0 37.571.282a6.866 6.866 0 0 0-4.6 2.925 7.494 7.494 0 0 0-1.577-1.7A6.838 6.838 0 0 0 26.072.078L25.941.1a6.888 6.888 0 0 0-4.733 3.116A7.033 7.033 0 0 0 14.53.366h-.012a7.3 7.3 0 0 0-5.855 8.465l.725 4.757-5.63 5.353A12.09 12.09 0 0 0 1.95 34.284l11.591 17.845c.014.022.03.044.045.065a16.994 16.994 0 0 0 13.633 7.114 15.912 15.912 0 0 0 2.427-.186l18.187-2.8c9.222-1.422 15.5-10.573 14-20.4-.678-4.393-1.179-7.67-1.586-10.331zM47.4 53.532l-18.184 2.806a14 14 0 0 1-13.334-5.778L4.313 32.748A9.27 9.27 0 0 1 5.7 20.983l4.206-4 1.244 8.157a1.409 1.409 0 1 0 2.786-.425l-1.648-10.806-.006-.043-.833-5.461a4.478 4.478 0 0 1 3.491-5.25h.009a4.478 4.478 0 0 1 4.918 3.958l.187 1.214c.01.081.021.161.034.242 0 .035.012.068.019.1l1.511 9.8a1.409 1.409 0 1 0 2.786-.429l-1.557-10.1a4.457 4.457 0 0 1 3.524-5.059l.131-.021a4.053 4.053 0 0 1 3.145.862 4.85 4.85 0 0 1 1.773 3.1l.295 1.911V8.762l1.085 7.026a1.409 1.409 0 0 0 2.786-.429L34.5 8.309a4.478 4.478 0 0 1 3.513-5.242 4.478 4.478 0 0 1 4.918 3.958l1.023 6.636a1.409 1.409 0 1 0 2.786-.429l-.553-3.584v-.01a4.849 4.849 0 0 1 .758-3.487 4.049 4.049 0 0 1 2.74-1.767l.125-.019a4.477 4.477 0 0 1 4.915 3.944c1.233 7.874 1.642 10.552 2.736 17.709l1.581 10.332c1.27 8.291-3.95 16-11.637 17.183zm0 0",
    className: "cls-4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup416);
export default __webpack_public_path__ + "static/media/Group 416.d53cb2034ea426fc617a5eeea81929d1.svg";
export { ForwardRef as ReactComponent };